import { render, staticRenderFns } from "./TourGetView.vue?vue&type=template&id=9dc702e6&scoped=true"
import script from "./TourGetView.vue?vue&type=script&lang=js"
export * from "./TourGetView.vue?vue&type=script&lang=js"
import style0 from "./TourGetView.vue?vue&type=style&index=0&id=9dc702e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc702e6",
  null
  
)

export default component.exports